import { locationIdToProperties as toLocationProperties } from '@fielded/fs-api/lib/tools'

export const resolveLocationScope = (locationId) => {
  const properties = toLocationProperties(locationId)
  const { level } = properties

  if (!level) {
    return {}
  }

  if (level === 'national') {
    return { country: properties.country }
  }

  return { [level]: properties[level] }
}
